module.exports = __webpack_public_path__ + "static/media/fondo_app.bdf96337.webp";